import { SystemRoleV2Enum } from '../interface/SystemRoleV2Enum';
export const ROLE_PERMISSION = Object.keys(SystemRoleV2Enum).reduce((acc, key) => ({
    ...acc,
    [key]: key,
}), {});
//# sourceMappingURL=role-permission.js.map